/**
 * @file: useImagePreviewSize.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { ImageAnnotationMetadata } from '@euler/app/flows/media/annotation/functions/AnnotationMetadata';
import { useIsMobileLayout } from '@euler/functions/responsiveness';

export const useImagePreviewSize = (options: {
  mask?: { width: number; height: number };
  container: { width: number; height: number };
  annotationMetadata?: ImageAnnotationMetadata;
}) => {
  const dimens = options.container;
  const mask = options.mask;
  const annotationMetadata = options.annotationMetadata;
  const isMobileLayout = useIsMobileLayout();
  let width = 0;
  let height = 0;
  if (isMobileLayout) {
    width = dimens.width;
    height = mask
      ? (mask.height / mask.width) * width
      : annotationMetadata?.canvas
      ? (annotationMetadata.canvas.height / annotationMetadata.canvas.width) *
        width
      : width * (5 / 4) /* default aspect ratio */;
    if (height > dimens.height) {
      height = dimens.height;
      width = mask
        ? (mask.width / mask.height) * height
        : annotationMetadata?.canvas
        ? (annotationMetadata.canvas.width / annotationMetadata.canvas.height) *
          height
        : height * (4 / 5);
    }
  } else {
    height = dimens.height;
    width = mask
      ? (mask.width / mask.height) * height
      : annotationMetadata?.canvas
      ? (annotationMetadata.canvas.width / annotationMetadata.canvas.height) *
        height
      : height * (4 / 5);
    if (width > dimens.width) {
      width = dimens.width;
      height = mask
        ? (mask.height / mask.width) * width
        : annotationMetadata?.canvas
        ? (annotationMetadata.canvas.height / annotationMetadata.canvas.width) *
          height
        : width * (5 / 4);
    }
  }

  return [width, height];
};
